// extracted by mini-css-extract-plugin
module.exports = {"Container":"menu-select-item_Container__Ny9yT"};